import { createClient } from '@supabase/supabase-js'

// Configuration fournie au moment du build (CRA inline les variables REACT_APP_*).
// Définies via les build-args du Dockerfile, eux-mêmes alimentés par cloudbuild.yaml.
// Pour changer de projet Supabase : modifier les valeurs dans cloudbuild.yaml et rebuild.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  // Aide au debug si le build a été fait sans les variables d'environnement.
  console.error('[supabaseClient] REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY manquantes au build')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
